import api from "apis/hiringNeed";
import { WebApiRequest, HTTP_GET, HTTP_PUT, HTTP_POST } from "tools/webservice";

export const getInspectorHiringForecast = (id, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.inspectorHiringForecast(id),
  successCallback,
  mountedRef,
});

export const getInspectorHiringForecastHistory = (id, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.inspectorHiringForecastHistory(id),
  successCallback,
  mountedRef,
});

export const updateHiringStatus = (id, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: api.inspectorHiringForecast(id),
  payload,
  successCallback,
  mountedRef,
});

export const getInspectorHiringNotes = (id, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.inspectorHiringNotes(id),
  successCallback,
  mountedRef,
});

export const postInspectorHiringNote = (id, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.inspectorHiringNotes(id),
  payload,
  successCallback,
  mountedRef,
});